import { useMutation } from "@tanstack/react-query";
import {
  type ValidateCouponRequest,
  type ValidateCouponResult,
  postCouponsValidate,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: ValidateCouponResult) => void;
  onError?: (error: unknown) => void;
};

export const useValidateCouponMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: ValidateCouponRequest) => postCouponsValidate(data),
    ),
    onSuccess,
    onError,
  });
};
